var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.8501 24.85C55.5544 24.1794 56.4917 23.8087 57.4641 23.8161C58.4366 23.8234 59.3682 24.2083 60.0623 24.8894C60.7564 25.5706 61.1588 26.4947 61.1845 27.4669C61.2102 28.439 60.8572 29.3831 60.2001 30.1L40.2501 55.05C39.907 55.4195 39.493 55.716 39.0327 55.9218C38.5725 56.1276 38.0754 56.2385 37.5713 56.2479C37.0672 56.2572 36.5664 56.1648 36.0988 55.9762C35.6313 55.7875 35.2065 55.5065 34.8501 55.15L21.6201 41.92C21.2516 41.5767 20.9561 41.1627 20.7512 40.7027C20.5462 40.2427 20.436 39.7461 20.4271 39.2426C20.4182 38.7391 20.5108 38.2389 20.6994 37.772C20.888 37.3051 21.1688 36.8809 21.5249 36.5248C21.881 36.1687 22.3051 35.888 22.7721 35.6994C23.239 35.5108 23.7392 35.4182 24.2427 35.427C24.7462 35.4359 25.2428 35.5461 25.7027 35.7511C26.1627 35.956 26.5767 36.2516 26.9201 36.62L37.3901 47.085L54.7551 24.96C54.7863 24.9215 54.8197 24.8848 54.8551 24.85H54.8501Z",
    fill: "#46A6FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.04d7c05dd71dd59d5a71d608e254fff3.svg";
export { ForwardRef as ReactComponent };